module.exports = __webpack_public_path__ + "static/media/imageBackground.addceb0a.png";